// src/components/layout/Header.jsx

import React, { useState, useEffect } from "react";
import {
  Typography,
  Grid,
  Box,
  Tooltip,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  ListItemIcon,
  Button,
  Badge,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Logout } from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import NotificationsIcon from "@mui/icons-material/Notifications";
import getLogoPath from "../../utils/logoUtils";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logoutUser } from "../../store/slices/auth.slice";
import ScreenRecorderButton from "../common/ScreenRecorderButton";

const logo = getLogoPath();

const Header = ({ sidebarOpen, onToggleSidebar }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  
  // Notification state
  const [notificationAnchorEl, setNotificationAnchorEl] = useState(null);
  const notificationOpen = Boolean(notificationAnchorEl);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  // Fetch notifications on component mount
  useEffect(() => {
    // TODO: Replace with actual API call to fetch notifications
    // For now, using dummy data
    const dummyNotifications = [
      {
        id: 1,
        description: "New system update available",
        hyperlink_text: "Click here",
        created_at: new Date().toISOString(),
        is_read: false,
      },
      {
        id: 2,
        description: "Your profile has been updated",
        hyperlink_text: "View details",
        created_at: new Date().toISOString(),
        is_read: false,
      },
    ];
    
    setNotifications(dummyNotifications);
    setUnreadCount(dummyNotifications.filter(n => !n.is_read).length);
  }, []);

  const handleNotificationClick = (event) => {
    setNotificationAnchorEl(event.currentTarget);
  };

  const handleNotificationClose = () => {
    setNotificationAnchorEl(null);
  };

  const handleNotificationItemClick = (notificationId) => {
    // Mark notification as read
    setNotifications(prev => 
      prev.map(n => n.id === notificationId ? { ...n, is_read: true } : n)
    );
    setUnreadCount(prev => Math.max(0, prev - 1));
    // TODO: Call API to mark notification as read
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleMenuClose = () => setAnchorEl(null);
  
  const handleLogout = async () => {
    try {
      await dispatch(logoutUser()).unwrap();
    } catch (error) {
      } finally {
      navigate("/login");
    }
  };

  const handlehome = async () => {
    navigate('/');
  }

  return (
    <div className="top-bar">
      <Grid
        container
        spacing={2}
        justifyContent={"space-between"}
        alignItems="center"
      >
        <Grid
          item
          xs={6}
          md={6}
          lg={6}
          xl={6}
          sx={{ display: "flex", alignItems: "center", gap: 2 }}
        >
          <img src={logo} alt="Logo" onClick={handlehome} style={{ maxWidth: "110px", cursor: "pointer" }} />
          {sidebarOpen ? (
            <MenuOpenIcon
              onClick={onToggleSidebar}
              sx={{ cursor: "pointer" }}
            />
          ) : (
            <MenuIcon onClick={onToggleSidebar} sx={{ cursor: "pointer" }} />
          )}
        </Grid>

        <Grid item xs={6} md={6} lg={6} xl={6} sx={{ textAlign: "right" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            {/* Support Tooltip */}
            {/* <Tooltip title="Account settings" sx={{ marginRight: 3 }}>
              <Box display="flex" alignItems="center">
                <IconButton
                  size="small"
                  sx={{
                    mr: 2,
                    bgcolor: "var(--primary-color)",
                    color: "#fff",
                    width: 32,
                    height: 32,
                  }}
                >
                  ?
                </IconButton>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    marginRight: 2,
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", fontSize: "0.88rem" }}
                  >
                    Need Help
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ fontSize: "0.75rem", color: "text.secondary" }}
                  >
                    Contact Support
                  </Typography>
                </Box>
              </Box>
            </Tooltip> */}

            {/* Notification Bell Icon - Hidden */}
            {/* <Tooltip title="Notifications">
              <IconButton
                onClick={handleNotificationClick}
                size="small"
                sx={{ mr: 2 }}
              >
                <Badge badgeContent={unreadCount} color="error">
                  <NotificationsIcon sx={{ color: "var(--primary-color)" }} />
                </Badge>
              </IconButton>
            </Tooltip> */}

            {/* Notification Menu - Hidden */}
            {/* <Menu
              anchorEl={notificationAnchorEl}
              open={notificationOpen}
              onClose={handleNotificationClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              PaperProps={{
                sx: {
                  mt: 1.5,
                  minWidth: 350,
                  maxWidth: 400,
                  maxHeight: 400,
                  borderRadius: 2,
                  boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
                },
              }}
            >
              <Box sx={{ p: 2, borderBottom: "1px solid #e0e0e0" }}>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  Notifications
                </Typography>
                {unreadCount > 0 && (
                  <Typography variant="caption" color="text.secondary">
                    You have {unreadCount} unread notification{unreadCount > 1 ? "s" : ""}
                  </Typography>
                )}
              </Box>
              
              {notifications.length === 0 ? (
                <Box sx={{ p: 3, textAlign: "center" }}>
                  <Typography variant="body2" color="text.secondary">
                    No notifications
                  </Typography>
                </Box>
              ) : (
                <List sx={{ p: 0 }}>
                  {notifications.map((notification, index) => (
                    <React.Fragment key={notification.id}>
                      <ListItem
                        button
                        onClick={() => handleNotificationItemClick(notification.id)}
                        sx={{
                          backgroundColor: notification.is_read ? "transparent" : "#f5f5f5",
                          "&:hover": {
                            backgroundColor: "#e0e0e0",
                          },
                        }}
                      >
                        <ListItemText
                          primary={
                            <Typography
                              variant="body2"
                              sx={{
                                fontWeight: notification.is_read ? 400 : 600,
                              }}
                            >
                              {notification.description}
                            </Typography>
                          }
                          secondary={
                            <Box>
                              {notification.hyperlink_text && (
                                <Typography
                                  variant="caption"
                                  sx={{
                                    color: "var(--primary-color)",
                                    cursor: "pointer",
                                    "&:hover": { textDecoration: "underline" },
                                  }}
                                >
                                  {notification.hyperlink_text}
                                </Typography>
                              )}
                              <Typography variant="caption" display="block" color="text.secondary">
                                {new Date(notification.created_at).toLocaleString()}
                              </Typography>
                            </Box>
                          }
                        />
                      </ListItem>
                      {index < notifications.length - 1 && <Divider />}
                    </React.Fragment>
                  ))}
                </List>
              )}
              
              <Box sx={{ p: 1, borderTop: "1px solid #e0e0e0", textAlign: "center" }}>
                <Button
                  size="small"
                  sx={{ color: "var(--primary-color)" }}
                  onClick={() => {
                    handleNotificationClose();
                    navigate("/notification-configuration");
                  }}
                >
                  View All Notifications
                </Button>
              </Box>
            </Menu> */}

            {/* Screen recording (tab-only capture, saved to backend) */}
            <ScreenRecorderButton />

            {/* User Profile Card Popup */}
            <Box
              sx={{ display: "flex", alignItems: "center" }}
              onClick={handleMenuClick}
            >
              <Box mr={1}>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: "bold", fontSize: "0.88rem" }}
                >
                  Hi, {user?.name || user?.username}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ fontSize: "0.75rem", color: "text.secondary" }}
                >
                  {user?.current_role_name || user?.primary_role_name}
                </Typography>
              </Box>
              <Tooltip title="Account settings">
                <IconButton size="small" sx={{ ml: 1 }}>
                  <Avatar
                    sx={{ width: 32, height: 32 }}
                    src={user?.profilePic || undefined}
                  >
                    {user?.name?.charAt(0).toUpperCase() ||
                      user?.username?.charAt(0).toUpperCase() ||
                      "U"}
                  </Avatar>
                </IconButton>
              </Tooltip>
              <KeyboardArrowDownIcon />
            </Box>

            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              PaperProps={{
                sx: {
                  mt: 1.5,
                  minWidth: 250,
                  borderRadius: 2,
                  p: 2,
                  boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  py: 1,
                }}
              >
                <Avatar
                  src={user?.profilePic || undefined}
                  sx={{
                    width: 60,
                    height: 60,
                    mb: 1.5,
                    bgcolor: "#2E3A59",
                  }}
                >
                  {user?.name?.charAt(0).toUpperCase() ||
                    user?.username?.charAt(0).toUpperCase() ||
                    "U"}
                </Avatar>
                <Typography
                  variant="h6"
                  fontWeight={600}
                  sx={{ mb: 0.5 }}
                >
                  {user?.username}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "text.secondary", mb: 2 }}
                >
                  {user?.current_role_name || user?.primary_role_name}
                </Typography>
                <Button
                  variant="contained"
                  startIcon={<Logout />}
                  fullWidth
                  sx={{ 
                    borderRadius: 2, 
                    fontWeight: 600,
                    backgroundColor: "#E31E25",
                    color: "#fff",
                    "&:hover": {
                      backgroundColor: "#B91C22",
                    }
                  }}
                  onClick={handleLogout}
                >
                  Logout
                </Button>
              </Box>
            </Menu>

            {/* Only show the new profile card popup, old dropdown removed */}
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default Header;
